import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../common/controls/Input';
import Link from '../../../common/components/Link';
import Button from '../../../common/components/Button';
import Notification from '../../../common/components/Notification';

import { Wrapper, Title, LinksWrapper, ButtonsWrappers, Left, Right } from './styled-components';

const LoginBox = ({ onInputChange, onLogin, message, credentials: { username, password } }) => (
  <Wrapper>
    {message && <Notification message={message} />}
    <Title>Sign In</Title>
    <Input
      type="text"
      name="username"
      required
      label="login"
      value={username}
      placeholder="username"
      onChange={onInputChange}
    />
    <Input
      type="password"
      name="password"
      required
      label="password"
      value={password}
      placeholder="credentials"
      onChange={onInputChange}
    />
    <LinksWrapper between="xs">
      <Left xs={6}>
        <Link to="/forgot-password" fontSize="12px">
          Forgot Password
        </Link>
      </Left>
      <Right xs={6}>
        <Link to="/forgot-username" fontSize="12px">
          Forgot username
        </Link>
      </Right>
    </LinksWrapper>
    <ButtonsWrappers center="xs">
      <Left xs={8}>
        <Button name="login" label="Sign In" onClick={onLogin} primary />
      </Left>
    </ButtonsWrappers>
  </Wrapper>
);

LoginBox.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  credentials: PropTypes.shape({
    username: PropTypes.string,
    password: PropTypes.string
  }).isRequired,
  message: PropTypes.string
};

LoginBox.defaultProps = {
  message: null
};

export default LoginBox;



// WEBPACK FOOTER //
// ./src/views/officials-connect/components/LoginBox/index.jsx